import { Button, Box, Divider } from '@mui/material';
import { ChevronLeft, ChevronRight, Save, Send } from 'lucide-react';

export default function StepNavigation({ currentStep, totalSteps, onPrev, onNext, onSave, isLastStep, isSaving }) {
  return (
    <>
      <Divider sx={{ my: 4 }} />
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', gap: 1 }}>
          {currentStep > 1 && (
            <Button 
              variant="outlined" 
              onClick={onPrev} 
              startIcon={<ChevronLeft size={18} />}
              sx={{ textTransform: 'none' }}
            >
              Indietro
            </Button>
          )}
          <Button 
            variant="text" 
            onClick={onSave} 
            startIcon={<Save size={18} />} 
            disabled={isSaving}
            color="inherit"
            sx={{ textTransform: 'none', color: 'text.secondary' }}
          >
            Salva bozza
          </Button>
        </Box>
        <Button 
          variant="contained" 
          onClick={onNext} 
          endIcon={!isLastStep && <ChevronRight size={18} />}
          startIcon={isLastStep && <Send size={18} />}
          size="large"
          sx={{ 
            minWidth: 160, 
            textTransform: 'none',
            borderRadius: 2,
            boxShadow: 2
          }}
        >
          {isLastStep ? 'Conferma e invia' : 'Continua'}
        </Button>
      </Box>
    </>
  );
}